/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import AUModalComponent from '@aarhus-university/au-lib-react-components/build/cjs/modal';

class TimelineComponent extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.timeline !== prevState.timeline) {
      return {
        timeline: nextProps.timeline,
      };
    }

    if (nextProps.text !== prevState.text) {
      return {
        text: nextProps.text,
      };
    }

    if (nextProps.modal !== prevState.modal) {
      return {
        modal: nextProps.modal,
      };
    }

    return null;
  }


  constructor(props) {
    super(props);
    this.state = {
      timeline: props.timeline,
      showDetails: false,
    };

    this.selectedItemIndex = -1;

    this.closeModal = this.closeModal.bind(this);
    this.handleCircleClick = this.handleCircleClick.bind(this);
    this.handlePrevItem = this.handlePrevItem.bind(this);
    this.handleNextItem = this.handleNextItem.bind(this);
  }

  // Ved luk modal
  closeModal() {
    this.setState({ showDetails: false });
  }

  // Ved klik på cirkel
  handleCircleClick(Index) {
    this.setState({ showDetails: true });
    this.selectedItemIndex = Index;

    // Highlight valgt cirkel
    return this.state.timeline.map((item, i) => {
      $(`#circle-${i}`).removeClass('highlight');
      $(`#circle-${i}`).removeClass('last');

      if (Index > i) {
        $(`#circle-${i}`).addClass('highlight');
      } else if (Index === i) {
        $(`#circle-${i}`).addClass('highlight');
        $(`#circle-${i}`).addClass('last');
      }

      return [];
    });
  }

  // Forrige element
  handlePrevItem() {
    if (this.selectedItemIndex > 0) {
      this.selectedItemIndex = this.selectedItemIndex - 1;
      this.setState({ showDetails: this.state.showDetails });
    }
    return [];
  }


  // Næste element
  handleNextItem() {
    if (this.state.timeline.length - 1 > this.selectedItemIndex) {
      this.selectedItemIndex = this.selectedItemIndex + 1;
      this.setState({ showDetails: this.state.showDetails });
    }
    return [];
  }

  // Bladring mellem forrige og næste element
  renderPagerItem(Index) {
    return [
      <div className="item-pager" key="itemPager">
        {(() => {
          if (Index > 0) {
            return <button className="circle bg-color-dark prev fas fa-angle-left" onClick={e => this.handlePrevItem(e, false)} />;
          }
          return <div className="dummy-pager prev" />;
        })()}
        {(() => {
          if (this.state.timeline.length - 1 > Index) {
            return [<button className="circle bg-color-dark next fas fa-angle-right" onClick={e => this.handleNextItem(e, false)} />];
          }
          return <div className="dummy-pager next" />;
        })()}
        <div className="item-pager-year">{this.state.timeline[Index].item}</div>
      </div>,
    ];
  }

  // Render tidslinje
  renderTimeline() {
    return this.state.timeline.map((item, i) => {
      const ii = `item-${i}`;
      const iii = `circle-${i}`;
      return [
        <button
          className="item"
          key={ii}
          onClick={e => this.handleCircleClick(i, e, false)}
          id={iii}
        >
          <div className="year">{item.item}</div>
          <div
            className="circle bg-color timeline"
            id={ii}
          ><div className="dot" />
          </div>
          <div className="title">{item.title}</div>
        </button>,
      ];
    });
  }

  render() {
    return [
      <section key="timelinesection">
        {this.renderTimeline()}
      </section>,
      <div className="container" key="modalContainer">
        {(() => {
          if (this.state.showDetails && this.props.modal === 'true') {
            return [
              <AUModalComponent key="modal" show outsideClick closeButton={false} classNames="bg-color" >
                <div className="modal-row">{this.renderPagerItem(this.selectedItemIndex)}</div>
                <div className="modal-row">
                  <h1>{this.state.timeline[this.selectedItemIndex].title}</h1>
                  <p>{this.state.timeline[this.selectedItemIndex].text}</p>
                </div>
                <div className="modal-row">
                  <div className="buttons">
                    {(() => {
                if (this.state.timeline[this.selectedItemIndex].link !== '') {
                  return [<a href={this.state.timeline[this.selectedItemIndex].link} className="button-modal bg-color-dark">{this.props.text.read_more}</a>];
                }
                return [];
              })()}
                    {(() => {
                if (this.state.timeline[this.selectedItemIndex].movie !== '') {
                  return [<a href={this.state.timeline[this.selectedItemIndex].movie} className="button-modal bg-color-dark">{this.props.text.view_movie}</a>];
                }
                return [];
              })()}
                    {(() => {
                if (this.state.timeline[this.selectedItemIndex].souce !== '') {
                  return [<a href={this.state.timeline[this.selectedItemIndex].source} className="button-modal bg-color-dark">{this.props.text.source}</a>];
                }
                return [];
              })()}
                  </div>
                  <button
                    className="close-button circle bg-color-dark fas fa-times"
                    onClick={() => {
                    this.closeModal();
                }}
                  />
                </div>
              </AUModalComponent>,
            ];
          } else if (this.state.showDetails && this.props.modal === 'false') {
            return [
              <div className="timeline-detail-view" key="timelinedetailview">
                <div className="row-container">
                  <button
                    className="close-button circle fas fa-times close-detail-view"
                    onClick={() => {
                      this.closeModal();
                  }}
                  />
                  <div className="row"><h2>{this.state.timeline[this.selectedItemIndex].item} - {this.state.timeline[this.selectedItemIndex].title}</h2>{this.state.timeline[this.selectedItemIndex].text}</div>
                  <div className="row read-more">
                    {(() => {
                      if (this.state.timeline[this.selectedItemIndex].link !== '') {
                        return [
                          <a href={this.state.timeline[this.selectedItemIndex].link} target="_blank" rel="noreferrer">
                            <div className="circle-label">
                              {this.props.text.read_more}
                            </div>
                            <div className="circle">
                              <i className="fas fa-angle-right" />
                            </div>
                          </a>];
                        }
                        return [];
                        })()}
                  </div>
                </div>
              </div>];
          }
          return null;
        })()}
      </div>,
    ];
  }
}

TimelineComponent.propTypes = {
  timeline: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  text: PropTypes.shape({
    view_movie: '',
    source: '',
    read_more: '',
  }).isRequired,
  modal: PropTypes.string.isRequired,
};

export default TimelineComponent;
